<template>
  <div>
    <BookingBreadcrumb :classes="{ booking_time: true }"/>
    <div class="text-center m-5 menu_explain-booking px-8">{{ this.bookingPermalink.note_date_and_time }}</div>
    <div class="container-fluid step-customer-booking">
      <div class="row select-therapist_wrapper">
        <div class="col-xs-12 font-hiraginoSans-w3">
          <v-select
            v-model="selectedTherapist"
            :options="availableTherapists"
            placeholder="担当者"
            label="name"
            :clearable="false"
            :searchable="false"
            disabled="disabled"
            class="mb-5 select-therapist"
          >
          </v-select>
          <div v-if="bookingInfo.customer_pick_therapist && bookingTherapist" class="therapist-info mb-5">
            <div class="therapist-img-booking mb-3 mr-4">
              <img
                  :src="bookingTherapist.image && bookingTherapist.image.url ? bookingTherapist.image.url : '/images/user-chat.png'"
                  :alt="bookingTherapist.name"
                  :title="bookingTherapist.name"
                  class="therapist-img"
              />
            </div>
            <div class="text-therapist-booking">
              {{ bookingTherapist.catch_copy }}
            </div>
          </div>
          <p class="mb-5 text-therapist">ご希望の日時を選択してください。</p>
        </div>
      </div>
    </div>
    <div class="container-fluid step-customer-booking">
      <div class="row m-1">
        <div class="row">
          <div class="col-md-12">
            <div class="customer-pick-time">
              <FullCalendar ref="editBookingCalendar" class="calendar" :options="calendarOptions" v-if="bookingInfo.id"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import BookingBreadcrumb from './BookingBreadcrumb.vue'
export default {
  name: 'EditBookingCalendar',
  components: {
    BookingBreadcrumb,
    FullCalendar
  },
  data() {
    return {
      bookingId: null,
      isLoading: false,
      currentEvents: [],
      selectedTherapist: { id: 0, name: '指名なし' },
    };
  },
  computed: {
    ...mapGetters('booking_edit', ['bookingInfo','bookingPermalink', 'bookingTherapist']),
    availableTherapists() {
      let options = [{ id: 0, name: '指名なし' }];
      if (this.bookingInfo.customer_pick_therapist) {
        this.selectedTherapist = this.bookingTherapist;
        options.push(this.bookingTherapist);
      } else {
        this.selectedTherapist = { id: 0, name: '指名なし' };
      }
      return options;
    },
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        headerToolbar: {
          left: 'prev',
          center: 'title',
          right: 'next',
        },
        titleFormat: {year: 'numeric', month: 'short'},
        dayHeaderContent: (args) => {
          const day = args.date.getDate();
          const weekday = args.date.toLocaleDateString('ja-JP', { weekday: 'short' });
          return `${day} (${weekday})`;
        },
        selectable: true,
        contentHeight: 'auto',
        datesAboveResources: true,
        selectOverlap: false,
        allDaySlot: false,
        locale: 'ja',
        timeZone: 'Asia/Tokyo',
        initialView: 'timeGridWeek',
        firstDay: moment().format('e'),
        height: 'auto',
        editable: true,
        slotLabelFormat: {
          hour: 'numeric',
          minute: '2-digit',
          omitZeroMinute: false,
        },
        slotLabelInterval: this.bookingPermalink?.slot_duration,
        slotDuration: this.bookingPermalink?.slot_duration,
        slotMinTime: this.bookingPermalink?.min_time_routine,
        slotMaxTime: this.bookingPermalink?.max_time_routine,
        events: (info, successCallback, failureCallback) => {
          const start = moment(info.start);
          const end = moment(info.end);
          const promises = [];
          for (let date = start; date.isBefore(end); date.add(1, 'days')) {
            const formattedDate = date.format("YYYY-MM-DD");
            const url = Routes.customer_bookings_api_v1_front_booking_path({
              id: this.$route.params.id,
              format: 'json'
            });
            const params = {
              date: formattedDate,
              timeZone: 'Asia/Tokyo'
            };
            axios.get(url, { params })
            .then(response => {
              const events = response.data;
              promises.push(...events);
              this.$refs.editBookingCalendar.getApi().addEventSource(events);
              this.handleLoading(false);
              successCallback(promises);
            })
            .catch(error => {
              failureCallback(error);
            });
          }
        },
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventClick: this.handleEventClick
      };
    },
  },
  methods: {
    ...mapActions('booking_edit', ['setBookingEvent', 'setBookingLoading']),
    handleLoading(isLoading) {
      this.setBookingLoading(isLoading);
    },
    handleEventClick(info) {
      const event = info.event
      if (event.classNames.includes('in-working-time') && event.classNames.includes('scroll-top')) {
        const bookingTime = {
          start: event.start,
          end: event.end,
          startStr: event.startStr,
          endStr: event.endStr
        }
        this.setBookingEvent(bookingTime);
      }
    },
  }
}
</script>
<style scoped>
.footer-form-mobile {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
}

.button-back a {
  color: #070807;
  text-decoration: none;
  font-weight: bold;
}

.mt-3 {
  margin-top: 1rem;
}

.select-group {
  margin-bottom: 20px;
}

.select-group select {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  font-size: 16px;
  font-weight: bold;
  background-color: #f0f0f0;
}

.therapist-info {
  display: flex;
  align-items: center;
  margin-top: 1rem;
}

.therapist-img {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: block;
}

.text-therapist-booking {
  font-family: HiraginoSans-W3;
  font-size: 14px;
  color: #00122E;
  flex: 1;
}

.select-therapist {
  width: 50%;
  .vs__dropdown-toggle {
    height: unset;
  }
}

@media (max-width: 768px) {
  .therapist-info {
    flex-direction: column;
    align-items: center;
  }

  .therapist-img-booking {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .therapist-info {
    flex-direction: row;
    align-items: center;
  }

  .therapist-img-booking {
    margin-right: 1rem;
    margin-bottom: 1rem;
  }

  .text-therapist-booking {
    text-align: left;
  }

  .select-therapist {
    width: 100%;
  }

  .select-therapist_wrapper {
    &.row {
      margin-left: -15px !important;
      margin-right: -15px !important;
    }
  }
}
</style>